import { $markSchema } from '@milkdown/kit/utils';

/** Legacy Platform `em`. Hydrate old Y.js docs; collab normalizer rewrites to Milkdown `emphasis`. */
export const emCompatMark = $markSchema('em', () => ({
  parseDOM: [
    { tag: 'i' },
    { tag: 'em' },
    {
      style: 'font-style',
      getAttrs: (value) => (value === 'italic' ? {} : false),
    },
  ],
  toDOM: () => ['em', 0],
  parseMarkdown: {
    match: () => false,
    runner: () => {},
  },
  toMarkdown: {
    match: (mark) => mark.type.name === 'em',
    runner: (state, mark, node) => {
      state.withMark(mark, 'emphasis', node.text || '', { marker: '_' });
    },
  },
}));

/** Platform `code_inline`; preset equivalent is `inlineCode`. */
export const codeInlineCompatMark = $markSchema('code_inline', () => ({
  priority: 100,
  code: true,
  parseDOM: [{ tag: 'code' }],
  toDOM: () => ['code', 0],
  parseMarkdown: {
    match: () => false,
    runner: () => {},
  },
  toMarkdown: {
    match: (mark) => mark.type.name === 'code_inline',
    runner: (state, mark, node) => {
      state.withMark(mark, 'inlineCode', node.text || '');
    },
  },
}));

/** Platform `strikethrough`; GFM preset uses `strike_through`. */
export const strikethroughCompatMark = $markSchema('strikethrough', () => ({
  parseDOM: [
    { tag: 'del' },
    {
      style: 'text-decoration',
      getAttrs: (value) => (value === 'line-through' ? {} : false),
    },
  ],
  toDOM: () => ['del', 0],
  parseMarkdown: {
    match: () => false,
    runner: () => {},
  },
  toMarkdown: {
    match: (mark) => mark.type.name === 'strikethrough',
    runner: (state, mark) => {
      state.withMark(mark, 'delete');
    },
  },
}));
